import React from 'react';
import image_main from "../../assets/main/main_logo.png";

import './MainSection.css';

const MainSection = () => {
    const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
      <section className="main-section section-green" id='main-section'>
        <div className="container">
          <div className="hero-wrap animated">
            <div className="content-left">
              <div className="logo-main">
                <img src={image_main} alt="One Learning Logo" />
              </div>
              <p className="description">
                Somos una red profesional de especialistas, consultores,
                diseñadores y<br />
                facilitadores que combina experiencia, innovación, investigación
                y arte.
              </p>
              <button onClick={() => scrollToSection("contact")} className="button button-main">Contactar</button>
            </div>
          </div>
        </div>
      </section>
  );
};

export default MainSection;